module.exports = __webpack_public_path__ + "media/santa_mix.be2fa21c.mp3";